/**
 * Personal access tokens: the credential an MCP client holds.
 *
 * `createToken` is the only call in this app whose response contains a secret, and it contains it
 * exactly once. Nothing here stores it, and there is no function to fetch it again, because there
 * is no endpoint that could serve one — the service keeps a SHA-256 digest and nothing else.
 */

import { authed } from "./authed";
import type { CreatedToken, PersonalToken } from "./types";

export function listTokens(signal?: AbortSignal): Promise<PersonalToken[]> {
  return authed<PersonalToken[]>("/tokens", { signal });
}

/** **The value is in this response and in no other, ever.** */
export function createToken(name: string): Promise<CreatedToken> {
  return authed<CreatedToken>("/tokens", { method: "POST", body: { name } });
}

/**
 * Revoke one token.
 *
 * Not instant, and the screen says so: the row is marked immediately, but a server instance that
 * resolved this token in the last minute keeps honouring it until its principal cache expires,
 * per instance. Somebody revoking a token from a lost laptop needs to know that.
 */
export function revokeToken(id: string): Promise<PersonalToken> {
  return authed<PersonalToken>(`/tokens/${id}`, { method: "DELETE" });
}
